export default {
  login: "Login",
  email: "Email",
  pass: "Password",
  ingresar: "Sign in",
  forgotPass: "Forgot your password?",
  recuperarPass: "Recover password",
  noRegistrado: "Not registered?",
  crearCuenta: "Create account",
  tieneCuenta: "Already have an account?",
  cuentaVencidaTitulo: "Your SatWeb account has expired!",
  cuentaVencidaText: "You need to renew your subscription to continue using SatWeb",
  cuentaFreeVencidaTitulo: "Your Free SatWeb account has expired!",
  cuentaFreeVencidaText: "You need to subscribe to a plan to use SatWeb",
  comprarAhora: "Buy now",
  renovarAhora: "Renew now",
  errorEmailPass: "You must enter both email and password",
  errorEmail: "You must enter an email",
  errorPass: "You must enter a password",
  acuerdo: "By clicking next, I agree to the",
  terminos: "Terms of use",
  siguiente: "Next",
  textCelular: "Enter your phone number to activate your SatWeb account",
  enviarSMS: "Send confirmation SMS",
  errorCelular: "Please enter a valid phone number",
  placeholderCelular: "Phone number",
  nuevaPass: "New password",
  confirmPass: "Confirm password",
  passLargo: "Password must be at least 8 characters long.",
  passMayus: "Password must contain at least one uppercase letter.",
  passMinuscula: "Password must contain at least one lowercase letter.",
  passNum: "Password must contain at least one number.",
  passCaracter: "Password must contain at least one special character.",
  restablecerPass: "Reset password",
  pregLogin: "Do you want to log in?",
  emailVacio: "Please enter an email address",
  emailInvalido: "Invalid email address",
  enviarEmail: "Send email",
  passActual: "Current password",
  noCoincide: "Must match the new password",
  errorCredenciales: "Incorrect username or password",
  errorCuenta: "Account expired",

}
